module.exports = __webpack_public_path__ + "assets/webgl/Concrete_Wall_normal.13646baa.jpg";